import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-background text-foreground brand-hero-bg grain relative overflow-hidden flex items-center justify-center px-6">
      <div className="absolute -top-40 -right-40 w-[560px] h-[560px] rounded-full opacity-25 pointer-events-none" style={{ background: "radial-gradient(circle, rgba(139,92,246,0.5), transparent 65%)" }} />
      <div className="glass-card p-10 w-full max-w-lg text-center" data-testid="payment-cancel-card">
        <XCircle className="w-16 h-16 text-muted-foreground mx-auto" strokeWidth={1.5} />
        <h1 className="mt-4 font-display font-black text-3xl tracking-tighter">Checkout cancelled.</h1>
        <p className="mt-2 text-muted-foreground">No charge was made. Whenever you&apos;re ready, come back and pick a plan.</p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Link to="/pricing" data-testid="pricing-back-btn" className="tenant-btn rounded-full px-6 h-11 font-display font-bold text-sm inline-flex items-center gap-2">
            <ArrowLeft className="w-4 h-4" /> Back to pricing
          </Link>
          <Link to="/console/dashboard" data-testid="console-btn" className="gradient-stroke rounded-full px-6 h-11 font-display font-bold text-sm inline-flex items-center">
            Return to console
          </Link>
        </div>
      </div>
    </div>
  );
}
